import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOSchema
        type="page"
        title="Terms of Service - KakobuySheet Kakobuy Spreadsheet Directory"
        description="KakobuySheet Terms of Service. Read the terms governing the use of our Kakobuy Spreadsheet directory, including intellectual property, liability limitations, and usage guidelines."
        url="https://kakobuy.boutique/terms"
        dateModified="2026-06-25"
      />
      <Navbar />
      <main className="pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
            <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 font-medium">Terms of Service</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6">Terms of Service</h1>
          <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
            <p>By accessing and using KakobuySheet, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please discontinue use of our website.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Use of Service</h2>
            <p>KakobuySheet provides a directory of <strong>Kakobuy Spreadsheet</strong> links and informational content for personal, non-commercial use. You agree to use our website only for lawful purposes and in accordance with these terms.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Intellectual Property</h2>
            <p>All original content on KakobuySheet, including articles, guides, and directory organization, is protected by applicable copyright laws. You may share links to our content but may not reproduce, distribute, or modify our content without permission.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Limitation of Liability</h2>
            <p>KakobuySheet shall not be liable for any damages arising from the use of our website or reliance on any <strong>Kakobuy Spreadsheet</strong> links provided. We provide resources as-is, without warranties of any kind.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Changes to Terms</h2>
            <p>We reserve the right to modify these terms at any time. Continued use of the website after changes constitutes acceptance of the updated terms.</p>
          </div>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm">
              <i className="ri-arrow-left-line"></i> Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}